import {
  type HttpEvent,
  type HttpHandlerFn,
  type HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@application/auth/auth.service';
import { Observable } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);

  const usuario = authService.usuario();
  let authRequest = req;

  if (usuario?.token) {
    authRequest = req.clone({
      setHeaders: {
        Authorization: `${usuario?.token}`
      }
    });
  }

  return next(authRequest);
};
